


(function () {
  if (window.mmCAA) return;

  var cfg = window.mmCAAConfig || {};
  var SHOP_ID = String(cfg.shopId || '');
  var CLIENT_ID = String(cfg.clientId || '');
  var VERSION = String(cfg.apiVersion || '2025-07');
  var REDIRECT = String(cfg.redirectUri || '');
  var DEBUG = !!cfg.debug;

  var TOKEN_KEY = 'mm_caa_token';

  var configured = !!(SHOP_ID && CLIENT_ID && REDIRECT);

  function log() {
    if (!DEBUG || !window.console) return;
    try { console.log.apply(console, ['[mmCAA]'].concat([].slice.call(arguments))); } catch (e) {}
  }

  function readToken() {
    try {
      var raw = JSON.parse(sessionStorage.getItem(TOKEN_KEY) || 'null');
      if (!raw || !raw.token || !raw.expires) return null;
      if (Date.now() > raw.expires - 60000) return null;
      return raw.token;
    } catch (e) { return null; }
  }

  function writeToken(token, expiresInSeconds) {
    try {
      sessionStorage.setItem(TOKEN_KEY, JSON.stringify({
        token: token,
        expires: Date.now() + (Number(expiresInSeconds) || 7200) * 1000
      }));
    } catch (e) {}
  }

  function randomString(bytes) {
    var a = new Uint8Array(bytes);
    (window.crypto || window.msCrypto).getRandomValues(a);
    var s = '';
    for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2);
    return s;
  }

  function base64url(buffer) {
    var bin = '';
    var b = new Uint8Array(buffer);
    for (var i = 0; i < b.length; i++) bin += String.fromCharCode(b[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function challengeFor(verifier) {
    return window.crypto.subtle
      .digest('SHA-256', new TextEncoder().encode(verifier))
      .then(base64url);
  }


  function handleCallbackIfPresent() {
    if (!window.opener || window.opener === window) return false;
    var params = new URLSearchParams(window.location.search);
    var code = params.get('code');
    var state = params.get('state');
    var error = params.get('error');
    if (!code && !error) return false;

    try {
      window.opener.postMessage({
        source: 'mm-caa',
        code: code,
        state: state,
        error: error || (params.get('error_description') || null)
      }, window.location.origin);
    } catch (e) {}

    setTimeout(function () { window.close(); }, 50);
    return true;
  }


  var inFlight = null;

  function authorize() {
    if (inFlight) return inFlight;

    inFlight = new Promise(function (resolve) {
      var verifier = randomString(32);
      var state = randomString(16);
      var nonce = randomString(16);

      challengeFor(verifier).then(function (challenge) {
        var url = 'https://shopify.com/authentication/' + encodeURIComponent(SHOP_ID) + '/oauth/authorize'
          + '?client_id=' + encodeURIComponent(CLIENT_ID)
          + '&response_type=code'
          + '&redirect_uri=' + encodeURIComponent(REDIRECT)
          + '&scope=' + encodeURIComponent('openid email customer-account-api:full')
          + '&state=' + encodeURIComponent(state)
          + '&nonce=' + encodeURIComponent(nonce)
          + '&code_challenge=' + encodeURIComponent(challenge)
          + '&code_challenge_method=S256';

        var popup = window.open(url, 'mm-caa-auth', 'width=520,height=680,menubar=no,toolbar=no');
        if (!popup) { log('popup blocked'); return finish(null); }

        var settled = false;

        function finish(token) {
          if (settled) return;
          settled = true;
          window.removeEventListener('message', onMessage);
          clearInterval(watch);
          inFlight = null;
          resolve(token);
        }

        var exchanging = false;
        var closedSince = 0;

        function onMessage(ev) {
          if (ev.origin !== window.location.origin) return;
          var d = ev.data;
          if (!d || d.source !== 'mm-caa') return;
          if (d.error || !d.code) { log('authorize failed', d.error); return finish(null); }
          if (d.state !== state) { log('state mismatch'); return finish(null); }

          exchanging = true;
          clearInterval(watch);

          exchange(d.code, verifier).then(finish, function () { finish(null); });
        }

        window.addEventListener('message', onMessage);

        var watch = setInterval(function () {
          if (!popup.closed) { closedSince = 0; return; }

          if (exchanging) return;
          if (!closedSince) { closedSince = Date.now(); return; }
          if (Date.now() - closedSince < 1500) return;

          log('popup closed without a code');
          finish(null);
        }, 300);

        setTimeout(function () { if (!settled) { try { popup.close(); } catch (e) {} finish(null); } }, 120000);
      }, function () { inFlight = null; resolve(null); });
    });

    return inFlight;
  }

  function exchange(code, verifier) {
    var body = new URLSearchParams();
    body.set('grant_type', 'authorization_code');
    body.set('client_id', CLIENT_ID);
    body.set('redirect_uri', REDIRECT);
    body.set('code', code);
    body.set('code_verifier', verifier);

    return fetch('https://shopify.com/authentication/' + encodeURIComponent(SHOP_ID) + '/oauth/token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }).then(function (r) {
      if (!r.ok) throw new Error('token ' + r.status);
      return r.json();
    }).then(function (j) {
      if (!j || !j.access_token) throw new Error('no token');
      writeToken(j.access_token, j.expires_in);
      log('token acquired');
      return j.access_token;
    });
  }


  var api = {
    configured: configured,

    ready: function () { return !!readToken(); },

    token: function (interactive) {
      var t = readToken();
      if (t) return Promise.resolve(t);
      if (!configured || !interactive) return Promise.resolve(null);
      return authorize();
    },

    lastFailure: null,

    query: function (query, variables, interactive) {
      api.lastFailure = null;
      if (!configured) { api.lastFailure = 'auth'; return Promise.resolve(null); }
      return api.token(interactive).then(function (token) {
        if (!token) { api.lastFailure = 'auth'; return null; }
        return fetch('https://shopify.com/' + encodeURIComponent(SHOP_ID) + '/account/customer/api/' + VERSION + '/graphql', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Authorization: token },
          body: JSON.stringify({ query: query, variables: variables || {} })
        }).then(function (r) {
          if (r.status === 401) {
            try { sessionStorage.removeItem(TOKEN_KEY); } catch (e) {}
            api.lastFailure = 'auth';
            return null;
          }
          if (!r.ok) { api.lastFailure = 'http'; throw new Error('caa ' + r.status); }
          return r.json();
        }).then(function (j) {
          if (j && j.errors) log('graphql errors', j.errors);
          return j;
        }).catch(function (e) {
          if (!api.lastFailure) api.lastFailure = 'network';
          log('query failed', api.lastFailure, e);
          return null;
        });
      });
    }
  };

  window.mmCAA = api;

  handleCallbackIfPresent();
})();
